/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { stageEnumSchema } from "./stageEnumSchema.ts";

export const deliveryStageSchema = z.object({
	stage: stageEnumSchema.describe(
		"* `waiting_payment` - Ожидает оплаты\n* `accepted` - Принят\n* `cooking` - Готовится\n* `ready` - Собран\n* `on_way` - Курьер в пути\n* `delivered` - Доставлен\n* `completed` - Выдан\n* `cancelled` - Отменён\n* `failed` - Не удалось оформить",
	),
	is_done: z.boolean(),
	time: z.string().nullable().describe("Когда этап наступил, местное время точки."),
});
